
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State, Mutation } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import Regular from '@/components/regular/index.vue';

import * as _ from 'lodash';
import {
  getBannerList,
  pageVisit,
  getDataBanner,
  getIndexNav,
  popularizeList,
  popularizeReceive,
  popularizeClose,
  receiveFirstBuyCoupon,
  queryPrintSize,
  normalRecommend,
  dataNormalRecommend,
  printLabelSize,
  indexPostion,
  flashSalePageVisit,
  recommendProductInfo,
  deviceList
} from '@/services/http';
import { readCookie } from '@/tools/tools';
import hotList from '@/components/home/hotList.vue';
import classify from '@/components/home/classify.vue';

@Component({
  name: 'Home',
  components: {
    Header,
    Price,
    Footer,
    BackTop,
    hotList,
    classify,
    Regular
  }
})
export default class extends Vue {
  searchText: String = ''

  selectedDeviceId: any = 5 // 默认选中的设备ID

  showStauts: boolean = false

  devices: any = []

  isFixed: boolean = false

  bannerList: [] = []

  navList: any[] = []

  isFLash: boolean = false

  status: boolean = true

  isShowPaper: boolean = false

  // 开屏推广大图
  appSourceUrl: string = ''

  // 开屏推广小图
  smallSourceUrl: string = ''

  flashSaleId: string = ''

  searchWidth = '' // 搜索宽度

  searchHeight = '' // 搜索高度

  printSizeList: any[] = []

  objData: any = {}

  normalRecommendList: any[] = []

  // 首页推荐耗材
  recommendProductInfo: any = {}

  recommendNum: number = 1 // 热门推荐购买数量

  showProductInfor: boolean = false // 是否显示退耗材

  @Action('card/setCardNum') setCardNum!: Function

  @Action('user/setUserInfoList') setUserInfoList!: Function

  @Action('equipment/setPrinterModel') setPrinterModel!: Function

  @Mutation('home/ADDSMALLIMG') ADDSMALLIMG!: Function

  @Action('white/setWhiteStauts') setWhiteStauts!: Function

  @State('notifys') notifysState: any

  @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function

  // 根据搜索文本过滤设备列表
  get filteredDevices() {
    if (!this.searchText) {
      return this.devices;
    }
    return this.devices.filter((device: any) => device.name.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  handInput() {
    this.handData();
  }

  handTypeId(obj: any) {
    this.objData = obj;
  }

  handleIconClick() {
    this.searchText = '';
    this.handData();
  }

  handleGlobalClick(event: MouseEvent) {
    (this as any).$refs.classifyRef.sizeStauts = false;

    // 1. 提前返回的条件合并：如果弹窗关闭，或者事件目标不存在，则不做任何事
    if (!this.showStauts || !event.target) {
      return;
    }

    // 2. 获取豁免区的 DOM 元素
    const deviceSelectorElement = this.$refs.deviceSelectorRef as HTMLElement | undefined;

    // 创建一个包含所有豁免区域的列表
    const exemptedElements = [
      deviceSelectorElement
      // 【新增】将搜索框容器加入列表
      // searchBarElement,
    ];

    // 检查点击事件的目标是否在任何一个豁免区域内部
    const isClickInside = exemptedElements.some((el) =>
      // 使用 ?. 来安全地调用 contains
      el?.contains(event.target as Node));

    // 4. 如果点击【不在】豁免区内部，则关闭弹窗
    if (!isClickInside) {
      this.showStauts = false;
    }
  }

  handData() {
    deviceList({
      // productTypeId: obj.productTypeId?obj.productTypeId:obj.parentTypeId,//二级分类编号
      // productParentTypeId: obj.parentTypeId,//一级分类编号
      printerModel: this.searchText, // 打印机型号
      printerSize: '' // 打印机尺寸
    }).then((res: any) => {
      this.devices = res.data.data;

      // 根据选中的设备做首次加载
      const data = this.devices.filter((item: any) => item.useStatus == 1);
      if (data && this.status) {
        this.status = false;
        // this.selectDevice(data[0])
        this.selectedDeviceId = data[0]?.deviceId;
        this.setPrinterModel(null);
        this.setPrinterModel(data[0]);
      }
    });
  }

  async created() {
    await this.setCardNum();
    await this.getPopularizeList();
    await this.getPrintSize();
    await this.normalRecommend();
    await this.handData();
    // this.getIndexNav();
    await this.getBannerList();
    // ------------
    await this.pageVisit();
    await this.setWhiteStauts();
  }

  handTips() {
    (this as any).$refs.RegularRef.dialogVisible = true;
  }

  /**
   * 点击商品图片，进入商品详情页
   */
  goProductDetails() {
    this.$router.push(
      `/details?id=${this.recommendProductInfo.id}&productPriceId=${this.recommendProductInfo.productPriceId}`
    );
  }

  /**
   * 获取推荐耗材接口信息v2.1去除推荐耗材逻辑
   */
  async getrecommendProductInfo() {
    const res: any = await recommendProductInfo({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.recommendProductInfo = res.data.data;
      this.showProductInfor = true;
    } else {
      this.showProductInfor = false;
    }
  }

  // 选择设备
  selectDevice(item: any) {
    this.selectedDeviceId = item?.deviceId;
    this.setPrinterModel(item);
    this.showStauts = false;
  }

  // 清除选择
  clearSelection() {
    this.selectedDeviceId = null;
    this.setPrinterModel(null);
    this.showStauts = false;
  }

  /**
   * 推荐耗材去结算
   */
  goSettle() {
    const confirmlist = [
      {
        productId: this.recommendProductInfo.id,
        freight: null,
        id: this.recommendProductInfo.productPriceId,
        mallImage: {
          source_url: this.recommendProductInfo.listImagePath.sourceUrl,
          product_name: ''
        },
        natureList: [
          {
            id: '',
            index: 0,
            natureName: this.recommendProductInfo.productSize,
            natureValue: this.recommendProductInfo.productMaterial
          }
        ],
        num: this.recommendNum,
        price: this.recommendProductInfo.lowestPrice.split(',')[0],
        totalPrice: _.round(
          _.multiply(
            Number(this.recommendProductInfo.lowestPrice.split(',')[0]),
            this.recommendNum
          ),
          2
        )
      }
    ];
    this.CONFIRMORDER(confirmlist);
    this.$router.push('/orderconfirm?type=2');
  }

  // 获取常用推荐
  async normalRecommend() {
    const res: any = await normalRecommend({
      companyId: 1
    });
    this.normalRecommendList = res.data.data;
  }

  goodsgo(id: number) {
    const anchor = readCookie('anchor');
    dataNormalRecommend({
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.7.1.0.0.0.1',
      companyId: 1
    });
    this.$router.push(`/details?id=${id}&from=hotlist`);
  }

  // 获取打印尺寸
  async getPrintSize() {
    const res: any = await queryPrintSize({
      channel: 1
    });
    this.printSizeList = res.data.data;
  }

  // 到搜索页面
  goSearch(item: string) {
    const anchor = readCookie('anchor');
    printLabelSize({
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.8.2.0.0.0.1',
      companyId: 1,
      printSize: item,
      isInput: 1
    });
    this.$router.push(`/classify?keyword=${item}`);
  }

  goClassify() {
    // var data = {
    //   msgtype: 'cardMessage',
    //   cards:
    //     {
    //       type: 'product',// 商品
    //       data: [{
    //         id: '123', // 商品id
    //         picture: 'https://imagepc.ctaiot.com/mall/product_main_pic/f2033dc1-42a7-4145-b4bf-c82ee9b4a840.jpg', // 商品图片
    //         desc: '你好你好你好你好你好你好你好你好你好你好', // 描述
    //         title: '你好你好gggggggggggggggggggggggggg', // 标题
    //         price: '999999999',// 价格
    //         url: '' // actions 0的情况 跳转链接
    //       }]

    //     }
    //   ,// 这里是消息的配置，至少一条，具体配置看卡片类型定义
    // }

    //     var data = {
    //       // 要发送到的卡片消息数据对象
    //         "msgtype": "miniprogrampage",
    //         "title":"title",
    //         "name": "name",
    //         "headimg": "headimg",
    //         "pagepath":"pagepath",
    //         "thumb_media_id":"2GffOSv_K-3MgguUtgO6OG7c6ZvNrzW1agt4gzW37j7kFLZiuFyvRKLc_8irQzua",
    //         "thumburl": "https://imagepc.ctaiot.com/mall/product_main_pic/f2033dc1-42a7-4145-b4bf-c82ee9b4a840.jpg"
    // }

    //     // 将数据用postMessage的方式发送到七鱼
    //     window.parent.postMessage(data, '*');
    if (!this.searchWidth || !this.searchHeight) {
      return;
    }
    // let str: string = ''
    // if (this.searchWidth) {
    //   str = this.searchWidth
    // }
    // if (!this.searchWidth && this.searchHeight) {
    //   str = this.searchHeight
    // }
    // if (this.searchWidth && this.searchHeight) {
    //   str += `*${this.searchHeight}`
    // }
    const anchor = readCookie('anchor');
    printLabelSize({
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '3.8.1.0.0.0.1',
      companyId: 1,
      printSize: `${this.searchWidth}*${this.searchHeight}`,
      isInput: 0
    });
    this.$router.push(`/classify?keyword=${this.searchWidth}*${this.searchHeight}`);
  }

  async getBannerList() {
    const anchor = readCookie('anchor');
    const res: any = await getBannerList({
      companyId: 1,
      company: '',
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      platform: 2
    });
    this.bannerList = res.data.data;
  }

  async getIndexNav() {
    const res: any = await getIndexNav({ type: 2, companyId: 1 });
    if (res.data.code === 100) {
      this.navList = res.data.data.slice(0, 4);
    }
  }

  private async goDetails(jumpUrl: string) {
    const anchor = readCookie('anchor');
    const res: any = await getDataBanner({
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      eventNo: '2.4.0.0.0.0.0',
      companyId: 1
    });
    if (res.data.code === 100) {
      if (jumpUrl) {
        window.location.href = jumpUrl;
      }
    }
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 0,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }

  // 浏览更多
  watchMore(id: number) {
    this.$router.push(`/classify?parentTypeId=${id}`);
  }

  async openWin(item: any) {
    const anchor = readCookie('anchor');
    if (item.navType === 1) {
      this.$router.push(`/classify?productTypeId=${item.navTypeValue}`);
    } else if (item.navType === 2) {
      this.$router.push(`/details?id=${item.navTypeValue}`);
    } else if (item.navType === 3) {
      this.$router.push(`/special?id=${item.id}`);
    } else if (item.navName === '限时抢购') {
      const response: any = await flashSalePageVisit({
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
      if (response.data.code === 100) {
        window.location.href = item.jumpUrl;
      }
    } else {
      window.location.href = item.jumpUrl;
    }
  }

  // 查询开屏推广图片
  private async getPopularizeList() {
    const res: any = await popularizeList({
      showPostion: 1,
      companyId: 1
    });
    this.isFLash = res.data.data.length !== 0 && res.data.data[0].pcSourceUrl !== '';
    if (res.data.data.length !== 0) {
      this.appSourceUrl = res.data.data[0].pcSourceUrl;
      this.flashSaleId = res.data.data[0].id;
      if (this.appSourceUrl === '') {
        this.smallSourceUrl = res.data.data[0].smallSourceUrl;
      } else {
        this.smallSourceUrl = '';
      }
    } else {
      this.appSourceUrl = '';
      this.flashSaleId = '';
      this.smallSourceUrl = '';
    }
  }

  // 领取开屏推广
  private async popularizeReceive(str?: string) {
    const res: any = await popularizeReceive({
      id: this.flashSaleId,
      companyId: 1
    });
    if (res.data.code === 100) {
      this.getPopularizeList();
      if (str === 'isFlash') {
        this.isFLash = false;
      }
      this.$message.success('领取成功！');
    } else {
      this.$message.error(res.data.message);
    }
  }

  // 关闭开屏推广
  async closeSale() {
    this.isFLash = false;
    await popularizeClose({ id: this.flashSaleId });
    await this.getPopularizeList();
  }

  // 首购特惠广告图跳转链接
  async goLink() {
    const anchor = readCookie('anchor');
    indexPostion({
      bannerType: this.notifysState.serviceList.bannerType,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
    if (this.notifysState.serviceList.bannerType === 1) {
      const res: any = await receiveFirstBuyCoupon({
        companyId: 1
      });
      if (res.data.data === '') {
        this.$router.push('/coupon');
      } else {
        this.$message.success('领取成功！');
        this.$router.push('/coupon');
      }
    } else if (this.notifysState.serviceList.pcUrl !== '') {
      window.location.href = this.notifysState.serviceList.pcUrl;
    }
  }
}
